import { connectedAccountsStore } from '../store/store';
export function getSelectedAccount() {
    var store = connectedAccountsStore();
    if (store.selected >= 0) {
        return store.accounts[store.selected];
    }
    return null;
}
//# sourceMappingURL=getSelectedAccount.js.map